import React from "react";
import { Card, CardBody, Button, Table, Badge } from "reactstrap";
import { injectIntl } from "react-intl";
import moment from "moment";

const InventoryAuditList = ({ intl, data = [], onViewDetail }) => {
  const getStatusBadge = (status) => {
    switch (status) {
      case "draft":
        return <Badge color="secondary">Nháp</Badge>;
      case "in_progress":
        return <Badge color="warning">Đang kiểm</Badge>;
      case "completed":
        return <Badge color="success">Hoàn thành</Badge>;
      default:
        return <Badge color="light">{status}</Badge>;
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(value || 0);
  };

  if (data.length === 0) {
    return (
      <Card className="mb-4">
        <CardBody className="text-center text-muted">
          <i className="iconsminds-box-close" style={{ fontSize: "48px" }}></i>
          <p className="mt-3">Chưa có phiên kiểm kho nào</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="mb-4">
      <CardBody>
        <Table hover responsive>
          <thead>
            <tr>
              <th>Mã kiểm kho</th>
              <th>Ngày kiểm</th>
              <th className="text-center">Số nguyên liệu</th>
              <th className="text-center">Chênh lệch</th>
              <th className="text-center">Trạng thái</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((audit) => (
              <tr key={audit.id}>
                <td style={{ verticalAlign: "middle" }}>
                  <strong>{audit.audit_code}</strong>
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  {moment(audit.audit_date).format("DD/MM/YYYY")}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {audit.items?.length || 0}
                </td>
                <td
                  className={`text-center ${
                    audit.total_discrepancy_value > 0
                      ? "text-success"
                      : audit.total_discrepancy_value < 0
                      ? "text-danger"
                      : ""
                  }`}
                  style={{ verticalAlign: "middle" }}
                >
                  {formatCurrency(audit.total_discrepancy_value)}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {getStatusBadge(audit.status)}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  <Button
                    color="link"
                    size="sm"
                    onClick={() => onViewDetail && onViewDetail(audit)}
                  >
                    Chi tiết
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default injectIntl(InventoryAuditList);
